/**
 * Fonte da encomenda em MAIÚSCULAS (ONLINE, BALCÃO, COMERCIAL, EXPORTAÇÃO).
 * A cor vem da secção do ETICDATA (o nome é configurável nas Settings) para
 * as fontes se distinguirem de relance nas listas.
 */
const SECTION_STYLES: Record<string, string> = {
  "4": "border-sky-300 bg-sky-50 text-sky-800", // ONLINE
  "1": "border-amber-300 bg-amber-50 text-amber-800", // BALCÃO
  "2": "border-violet-300 bg-violet-50 text-violet-800", // COMERCIAL
  "3": "border-emerald-300 bg-emerald-50 text-emerald-800", // EXPORTAÇÃO
}
const FALLBACK_STYLE = "border-slate-400 bg-slate-100 text-slate-800"

export function SourceBadge({
  name,
  section,
  size = "md",
}: {
  name: string
  /** Secção do ETICDATA ("4" online, "1" balcão…) — dá a cor. */
  section?: string | null
  size?: "sm" | "md"
}) {
  return (
    <span
      className={
        "inline-flex items-center rounded-md border font-bold uppercase tracking-wide " +
        (SECTION_STYLES[String(section ?? "")] ?? FALLBACK_STYLE) +
        " " +
        (size === "sm" ? "px-1.5 py-0 text-[10px]" : "px-2.5 py-1 text-sm")
      }
    >
      {name}
    </span>
  )
}
